import HttpUtils from '../utils/HttpUtils'

async function getNetworkSummary() {
    const params = {
    }
    return await HttpUtils.sendJsonRPC('/v1','agg_getNetworkSummary',params);
}

async function getNetworkDailyMinerStats() {
    const params = {
    }
    return await HttpUtils.sendJsonRPC('/v1','agg_getNetworkDailyMinerStats',params);
}
async function queryOwnerStats(page?:number) {
    const params = {
        page:page
    }
    return await HttpUtils.sendJsonRPC('/v1','agg_queryOwnerStats',params);
}

async function getOwnerStatsByAddress(address:string) {
    const params = {
        address:address
    }
    return await HttpUtils.sendJsonRPC('/v1','agg_getOwnerStatsByAddress',params);
}
async function queryMinersByOwner(minerType:number,address:string,page?:number,pageSize?:number) {
    const params = {
        owner:address,
        page:page,
        limit:pageSize,
        minerType:minerType,
    }
    return await HttpUtils.sendJsonRPC('/v1','agg_queryMinersDetailByOwner',params);
}
async function getUserRewardLatest30DaysDashboard(address:string) {
    const params = {
        owner:address
    }
    return await HttpUtils.sendJsonRPC('/v1','agg_getUserRewardLatest30DaysDashboard',params);
}
async function queryMinersNetwork(minerType:number,page?:number,pageSize?:number) {
    const params = {
        page:page,
        limit:pageSize,
        minerType:minerType,
    }
    return await HttpUtils.sendJsonRPC('/v1','agg_queryMinersNetwork',params);
}
async function getMinerWithPlantInfo(minerType:number,minerAddress:string) {
    const params = {
        address:minerAddress,
        minerType:minerType,
    }
    return await HttpUtils.sendJsonRPC('/v1','agg_getMinerWithPlantInfo',params);
}
async function queryMinerDailyEnergy(minerType:number,miner_address:string,page?:number,limit?:number) {
    const params = {
        miner_address:miner_address,
        page:page,
        limit:limit,
        minerType:minerType,
    }
    return await HttpUtils.sendJsonRPC('/v1','agg_queryMinerDailyEnergy',params);
}
async function queryMinerDailyReward(minerType:number,miner_address:string,page?:number,limit?:number) {
    const params = {
        miner_address:miner_address,
        page:page,
        limit:limit,
        minerType:minerType,
    }
    return await HttpUtils.sendJsonRPC('/v1','agg_queryMinerDailyReward',params);
}
async function getMinerDailyData(minerType:number,miner_address:string) {
    const params = {
        minerAddress:miner_address,
        minerType:minerType,
    }
    return await HttpUtils.sendJsonRPC('/v1','agg_getMinerDailyData',params);
}
async function queryAddress(address:string) {
    const params = {
        address:address,
    }
    return await HttpUtils.sendJsonRPC('/v1','agg_queryAddress',params);
}
async function queryPlantWithImages(page?:number,limit?:number) {
    const params = {
        page:page,
        limit:limit,
    }
    return await HttpUtils.sendJsonRPC('/v1','agg_queryPlantWithImages',params);
}
async function getPlantInfoByType(plantType:number,plantAddress:string) {
    const params = {
        plantType:plantType,
        plantAddress:plantAddress,
    }
    return await HttpUtils.sendJsonRPC('/v1','agg_getPlantInfoByType',params);
}
async function queryPlantEnergyRecords(plantType:number,plantAddress:string,page?:number,limit?:number) {
    const params = {
        plantType:plantType,
        plantAddress:plantAddress,
        page:page,
        limit:limit,
    }
    return await HttpUtils.sendJsonRPC('/v1','agg_queryPlantEnergyRecords',params);
}
const DataAggregatorApi ={
    getNetworkSummary:getNetworkSummary,
    getNetworkDailyMinerStats:getNetworkDailyMinerStats,
    queryOwnerStats:queryOwnerStats,
    getOwnerStatsByAddress:getOwnerStatsByAddress,
    queryMinersByOwner:queryMinersByOwner,
    getUserRewardLatest30DaysDashboard:getUserRewardLatest30DaysDashboard,
    queryMinersNetwork:queryMinersNetwork,
    getMinerWithPlantInfo:getMinerWithPlantInfo,
    queryMinerDailyEnergy:queryMinerDailyEnergy,
    queryMinerDailyReward:queryMinerDailyReward,
    getMinerDailyData:getMinerDailyData,
    queryAddress:queryAddress,
    queryPlantWithImages:queryPlantWithImages,
    getPlantInfoByType:getPlantInfoByType,
    queryPlantEnergyRecords:queryPlantEnergyRecords
}

export default DataAggregatorApi;
